import type { FormControl } from '@angular/forms';

import { ChangeDetectionStrategy, Component, effect, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-switch',
  imports: [MatSlideToggleModule, ReactiveFormsModule],
  template: `
    @if (control(); as control) {
      <mat-slide-toggle
        [attr.aria-describedby]="'wzb-switch-label-' + id"
        [disabled]="disabled()"
        [formControl]="control"
        [labelPosition]="labelPosition()"
        [hideIcon]="true"
      >
        <ng-content />

        <span class="visually-hidden">
          @if (control.value) {
            Activer
          } @else {
            Désactiver
          }
        </span>
      </mat-slide-toggle>
    }
  `,

  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchComponent {
  readonly control = input<FormControl | null>(null);
  readonly disabled = input<boolean>(false);
  readonly labelPosition = input<'before' | 'after'>('before');

  private static Counter = 0;
  readonly id = `wzb-toggle-${++SwitchComponent.Counter}`;

  constructor() {
    effect(() => {
      if (this.disabled() && this.control()) {
        this.control()!.disable({ emitEvent: false });
      }
    });
  }
}
